import { createSecureImageUrl, preprocessStreamUrl } from '../hooks/useM3UPlaylist';

export function parseM3U(content = '') {
  const lines = content.split('\n');
  const channels = [];
  let current = null;

  const getParam = (section, name) => {
    const regex = new RegExp(`${name}="([^"]*)"`, 'i');
    const match = section.match(regex);
    return match ? match[1] : '';
  };

  lines.forEach(line => {
    const trimmed = line.trim();
    if (trimmed.startsWith('#EXTINF')) {
      const comma = trimmed.indexOf(',');
      const params = trimmed.substring(0, comma);
      const name = trimmed.substring(comma + 1).trim();
      current = {
        name,
        tvgId: getParam(params, 'tvg-id'),
        tvgName: getParam(params, 'tvg-name') || name,
        originalLogoUrl: getParam(params, 'tvg-logo'),
        group: getParam(params, 'group-title') || 'Altro',
      };
      if (current.originalLogoUrl) {
        current.tvgLogo = createSecureImageUrl(current.originalLogoUrl);
      } else {
        current.tvgLogo = '';
      }
    } else if (trimmed && !trimmed.startsWith('#') && current) {
      current.originalUrl = trimmed;
      current.url = preprocessStreamUrl(trimmed);
      channels.push(current);
      current = null;
    }
  });

  return channels;
}
